/*
Monotype Foundry Platform API
Version 1.0.0

Definition: FoundryImageRequest

Properties:
  fileName: string
  fileType: string
  fileSize: number
  md5Checksum: string
  priority: string
*/

var FoundryImageRequest = (function () {
  function validateFoundryImageRequest (arg) {
    // Validate fileName
    if (arg.fileName && !(typeof arg.fileName === 'string')) {
      throw new Error('FoundryImageRequest.fileName: Wrong type: Got \'' + (typeof arg.fileName) + '\', but expected: \'string\'')
    }
    // Validate fileType
    if (arg.fileType && !(typeof arg.fileType === 'string')) {
      throw new Error('FoundryImageRequest.fileType: Wrong type: Got \'' + (typeof arg.fileType) + '\', but expected: \'string\'')
    }
    // Validate fileSize
    if (arg.fileSize && !(typeof arg.fileSize === 'number')) {
      throw new Error('FoundryImageRequest.fileSize: Wrong type: Got \'' + (typeof arg.fileSize) + '\', but expected: \'number\'')
    }
    // Validate md5Checksum
    if (arg.md5Checksum && !(typeof arg.md5Checksum === 'string')) {
      throw new Error('FoundryImageRequest.md5Checksum: Wrong type: Got \'' + (typeof arg.md5Checksum) + '\', but expected: \'string\'')
    }
    // Validate priority
    if (arg.priority && !(typeof arg.priority === 'string')) {
      throw new Error('FoundryImageRequest.priority: Wrong type: Got \'' + (typeof arg.priority) + '\', but expected: \'string\'')
    }
  }
  function buildFoundryImageRequest (arg) {
    var FoundryImageRequest = arg
    // Complete fileName
    // Expected Type: string
    FoundryImageRequest.fileName = FoundryImageRequest.fileName || ''
    // Complete fileType
    // Expected Type: string
    FoundryImageRequest.fileType = FoundryImageRequest.fileType || ''
    // Complete fileSize
    // Expected Type: number
    FoundryImageRequest.fileSize = FoundryImageRequest.fileSize || 0
    // Complete md5Checksum
    // Expected Type: string
    FoundryImageRequest.md5Checksum = FoundryImageRequest.md5Checksum || ''
    // Complete priority
    // Expected Type: string
    FoundryImageRequest.priority = FoundryImageRequest.priority || ''
    return FoundryImageRequest
  }
  return {
    validate: validateFoundryImageRequest,
    build: buildFoundryImageRequest
  }
})()

module.exports = FoundryImageRequest
